/**
 * Jobs Data Interface
 *   interacts with mulesoft api to get jobs data
 *   supports filtering/searching for clients
 */

// main data
let jobData = [];

// complete lists generated from jobs data
let locationList;
let categoryList;

function filterData(locations, categories, keywords) {
    return jobData.filter((obj) => {
        if (locations &&  Array.isArray(locations) && locations.length) {
            // check for any of the jobs location in filter list
            if (!obj.Job_Location.find((jobLocation) => locations.includes(jobLocation))) {
                return false;
            }
        }

        if (categories && Array.isArray(categories) && categories.length && !categories.includes(obj.Job_Category)) {
            return false;
        }

        // search job title by keywords
        if (keywords && Array.isArray(keywords) && keywords.length) {
            let regexString = '';
            keywords.forEach((keyword) => {
                regexString += `(?=.*${keyword})`;
            });
            const regExp = new RegExp(regexString,'i');
            return obj.Job_Posting_Title.search(regExp) !== -1;
        }

        return true;
    });
}

const serviceUrl = TheCloroxCompany.JOBS_API_URL;
// job-query
// job-detail?job_unique_identifier= JOBID-TEST-16

const JobsAPI  = {
    init: async () => {
        console.log('start api init');
        const url = `${serviceUrl}/job-query`;
        return fetch(url)
            .then((response) => response.json())
            .then((result) => {
                // console.log('init get call', result);

                jobData = result;

                // sort jobsData by desc Recruiting_Start_Date
                jobData.sort((a,b) => {
                   if (a.Recruiting_Start_Date < b.Recruiting_Start_Date) {
                       return 1;
                   }
                   if (b.Recruiting_Start_Date < a.Recruiting_Start_Date) {
                       return -1;
                   }
                   return 0;
                });

                // preprocess locations
                //  can be an array or single string
                //  convert single strings into arrays
                let locationsComplete = [];
                jobData.forEach((job) => {
                    if (!Array.isArray(job.Job_Location)) {
                        job.Job_Location = [job.Job_Location];
                    }
                    locationsComplete = locationsComplete.concat(job.Job_Location);
                });
                locationList = [...new Set(locationsComplete)].sort();

                categoryList = [...new Set(jobData.map(job => job.Job_Category))].sort();

                return true;
            }).catch((error) => {
                console.log('error from job data fetch', error);
                return false;
            });
    },

    getLocationList: (categories, keywords) => {
        const data = filterData(null, categories, keywords);
        const countMap = {};
        data.forEach((row) => {
            // count each of the locations in the job locations
            row.Job_Location.forEach((jobLocation) => {
                if (!countMap[jobLocation]) {
                    countMap[jobLocation] = 0;
                }
                countMap[jobLocation] += 1;
            });
        });

        const results = locationList.map(item => ({
            text: item,
            count: countMap[item] ?? 0,
        }));

        return results;
    },

    getCategorylist: (locations, keywords) => {
        const data = filterData(locations, null, keywords);
        const countMap = {};
        data.forEach((row) => {
            if (!countMap[row.Job_Category]) {
                countMap[row.Job_Category] = 0;
            }
            countMap[row.Job_Category] += 1;
        });

        const results = categoryList.map(item => ({
            text: item,
            count: countMap[item] ?? 0,
        }));

        return results;
    },

    getJobsQuery: (locations, categories, keyword, startRecord = 0, recordsPerPage = 100) => {
        // no filtering
        const results = filterData(locations,categories,keyword);
        return {
            data: results.slice(startRecord, startRecord + recordsPerPage),
            totalResults: results.length,
            startRecord,
        };
    },

    getJobDetail: async (jobid) => {
        const url = `${serviceUrl}/job-detail?job_unique_identifier=${jobid}`;
        return fetch(url)
            .then((response) => response.json())
            .then((result) => {
                // console.log(`return from ${url}`, result);
                return result;
            }).catch((error) => {
                console.log('error from getJobDetail fetch', error);
                return false;
            });
    },
};

export default JobsAPI;
